import React, { useState } from 'react'
import { Grid, makeStyles, Popover, TableCell, TableRow } from '@material-ui/core'
import { FormAutocomplete, FormInputText, FormSwitch } from '../../../dsn-kernel'
import { Origines, Types } from '../../../store/constants/fonction/fonction'
import DeleteIcon from '@material-ui/icons/Delete'
import Tooltip from '@material-ui/core/Tooltip'
import Box from '@material-ui/core/Box'
import { useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import { ContainerTitle } from '../../common/container-title'
import { RenvoieSelectPath } from './RenvoieSelectPath'

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(0.2),
      width: '49%',
      display: 'inline-block',
    },
  },
  margin: {
    margin: theme.spacing(1),
  },
  popper: {
    ...theme.mixins.gutters(),
    minWidth: 380,
    maxWidth: 600,
    margin: 'auto',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}))

export const ParametreItem = ({ index, useFormObj, deleteLigne }) => {
  const classes = useStyles()
  const { control, getValues, setValue } = useFormObj
  const param = getValues(`paramList.${index}`)
  const paramType = getValues(`paramList.${index}.parametre.type`)
  const paramReference = getValues(`paramList.${index}.parametre.reference`)
  const valeurOrigine = getValues(`paramList.${index}.valeurOrigine`)
  const [anchorElPopover, setAnchorElPopover] = useState(null)
  const referentiels = useSelector(state => state.referentiels.referentiels)
  const variableClients = useSelector(state => state.variableClientModule.variableClients)
  const variableContextes = useSelector(state => state.variableContexteModule.variableContextes)
  const fonctions = useSelector(state => state.fonctionModule.fonctions)
  const selectedOrigines = useWatch({ control, name: `paramList.${index}.origines` })
  const origineDefaut = useWatch({ control, name: `paramList.${index}.origineDefaut` })

  const renvoiePopover = event => {
    setAnchorElPopover(event.target)
  }
  const closePopover = () => {
    setAnchorElPopover(null)
  }

  const originesHandlerChange = (event, values, reason, details) => {
    if (reason === 'remove-option' || reason === 'clear') {
      if (!values.includes(origineDefaut)) {
        setValue(`paramList.${index}.origineDefaut`, null)
      }
    }
  }
  const origineDefautHandlerChange = (event, values, reason, details) => {
    setValue(`paramList.${index}.valeurOrigine`, null)
  }
  const validateValeurOrigine = value => {
    if (origineDefaut === 'VALEUR_SAISIE') {
      if (!value) return true
      return (
        Types[paramType].validate(value) ||
        "La valeur saisie n'est pas conforme au type '" + Types[paramType].label + "'"
      )
    }
    return true
  }
  let valeurOrigineOptions = null
  let getOptionLabel = option => (option ? `${option.nom}` : '')
  let getOptionSelected = (option, value) => option.nom === value.nom
  if (origineDefaut) {
    if (origineDefaut === 'VALEUR_SAISIE' && Types[paramType] === Types.REFERENCE) {
      getOptionLabel = option => (option ? `${option.code} - ${option.libelle}` : '')
      getOptionSelected = (option, value) => option.code === value.code
      valeurOrigineOptions = referentiels.find(ref => ref.nom === paramReference).values
    } else {
      if (origineDefaut === 'VARIBALE_CLIENT') {
        valeurOrigineOptions = variableClients
      } else if (origineDefaut === 'CONTEXTE') {
        valeurOrigineOptions = variableContextes
      } else if (origineDefaut === 'FONCTION') {
        valeurOrigineOptions = fonctions
      }
      valeurOrigineOptions =
        valeurOrigineOptions &&
        valeurOrigineOptions.filter(item => {
          if (Types[item.type] === Types.REFERENCE && Types[item.type] === Types[paramType]) {
            return paramReference === item.reference
          } else {
            return Types[item.type] === Types[paramType]
          }
        })

      if (valeurOrigine && valeurOrigineOptions) {
        setValue(
          `paramList.${index}.valeurOrigineObj`,
          valeurOrigineOptions.find(item => item.nom === valeurOrigine)
        )
      }
    }
  }

  var handleSelection = path => {
    setValue(`paramList.${index}.valeurOrigine`, path)
  }
  return (
    <TableRow>
      <TableCell>
        <Tooltip title={getValues(`paramList.${index}.parametre.description`)}>
          <Box>{getValues(`paramList.${index}.parametre.nom`)}</Box>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Box>
          {Types[paramType].label}
          {Types[paramType] === Types.REFERENCE ? ` [${paramReference}]` : ''}
        </Box>
      </TableCell>
      <TableCell>
        <FormSwitch name={`paramList.${index}.obligatoire`} control={control} />
      </TableCell>
      <TableCell>
        <FormAutocomplete
          name={`paramList.${index}.origines`}
          control={control}
          size={'small'}
          multiple
          options={Types[paramType].origines || Origines}
          rules={{ required: true }}
          onChange={originesHandlerChange}
        />
      </TableCell>
      <TableCell>
        <span className={classes.root}>
          {!!selectedOrigines.length && (
            <FormAutocomplete
              name={`paramList.${index}.origineDefaut`}
              control={control}
              size={'small'}
              options={selectedOrigines}
              disabled={!selectedOrigines.length}
              onChange={origineDefautHandlerChange}
            />
          )}
          {!!origineDefaut && !!valeurOrigineOptions && (
            <FormAutocomplete
              name={`paramList.${index}.valeurOrigineObj`}
              control={control}
              size={'small'}
              getOptionLabel={getOptionLabel}
              getOptionSelected={getOptionSelected}
              options={valeurOrigineOptions}
            />
          )}
          {!!origineDefaut && !valeurOrigineOptions && (
            <FormInputText
              name={`paramList.${index}.valeurOrigine`}
              control={control}
              disabled={!origineDefaut}
              rules={{
                required: !!origineDefaut,
                validate: validateValeurOrigine,
              }}
              type={Types[paramType] === Types.DATE && origineDefaut !== 'RENVOI' ? 'date' : ''}
              onClick={
                origineDefaut === 'RENVOI'
                  ? event => {
                      event.target.blur()
                      renvoiePopover(event)
                    }
                  : null
              }
            />
          )}
        </span>
        <Popover
          anchorEl={anchorElPopover}
          open={!!anchorElPopover}
          anchorPosition={{ top: 270, left: 660 }}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
        >
          <Paper className={classes.popper} elevation={1}>
            <ContainerTitle classes={classes} title="Choix du composant cible" />
            <Grid container direction="row" justify="flex-end">
              <RenvoieSelectPath
                classes={classes}
                handleClose={closePopover}
                selectedPath={valeurOrigine}
                parametre={param}
                handleSelection={handleSelection}
              />
            </Grid>
          </Paper>
        </Popover>
      </TableCell>
      <TableCell>
        <DeleteIcon onClick={() => deleteLigne(index)} />
      </TableCell>
    </TableRow>
  )
}
